import { Component } from '@angular/core';
import { AppLinks } from '../../app-links';
import { Router, RouterLink } from '@angular/router';
import { DatasearchBetaNewService } from '../../_services/datasearch-beta-new.service';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  footerdata: any = [];
  public appLinks = AppLinks;

  baseurl = '';
  constructor(
    private datasearch_service: DatasearchBetaNewService,
    private router: Router
  ) {}
  ngOnInit() {
    this.baseurl = this.datasearch_service.constants ? this.datasearch_service.constants.ApiUrl + '/uploads/layout-logos/' : 'http://localhost:5001/uploads/layout-logos/';
    this.getfooterData();
  }
  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }
  getfooterData() {
    this.datasearch_service.getFooter().subscribe(
      (res) => {
        if (res && (res.success || res.status)) {
          this.footerdata = Array.isArray(res.data) ? res.data[0] : res.data;
        }
      },
      (error) => {
        console.error('Error fetching footer data', error);
      }
    );
  }
}
